import React, {PureComponent} from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { Card, CardBody, Col } from 'reactstrap';
import BellIcon from 'mdi-react/BellIcon'
import NewIcon from 'mdi-react/MoneyIcon'
import LetterIcon from 'mdi-react/EnvelopeIcon'
import BuildIcon from 'mdi-react/BuildIcon'

//const data = [{ value: 360, fill: '#f6da6e' }];

export default class PieNewDeals extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            //modal: false
        };
    }

    getIcon = () => {
      if(this.props.type === 'new') {
          return <NewIcon style={{ fill: '#f6da6e', marginTop: '30px' }} />;
      }
      else if(this.props.type === 'envelope') {
          return <LetterIcon style={{ fill: '#70bbfd', marginTop: '30px' }} />;
      }
      else if(this.props.type === 'maint') {
          return <BuildIcon style={{ fill: '#c88ffa', marginTop: '30px' }} />;
      }
      else if(this.props.type === 'remind') {
          return <BellIcon style={{ fill: '#4ce1b6', marginTop: '30px' }} />;
      }
      else {
          return <div/>;
      }
    };


    render() {

        let value = 0;

        if(this.props.data && this.props.data[0] && this.props.data[0].value) {
            value = this.props.data[0].value;
        }

        return (
            <Card>
                <CardBody className="dashboard__health-chart-card" style={{padding: 0}}>
                    <div className="dashboard__health-chart">
                        <ResponsiveContainer height={90}>
                            <PieChart>
                                <Pie data={this.props.data} dataKey="value" cy={42} innerRadius={40} outerRadius={45}/>
                            </PieChart>
                        </ResponsiveContainer>
                        <div className="dashboard__health-chart-info">
                            {/*this.props.type === 'new' ? <NewIcon style={{ fill: '#f6da6e', marginTop: '30px' }} /> : <LetterIcon style={{ fill: '#70bbfd', marginTop: '30px' }} /> */}
                            {this.getIcon()}
                            <p className="dashboard__health-chart-number" style={{marginTop: '-10px'}}>{value}</p>
                        </div>
                    </div>
                    <p className="dashboard__goal">{this.props.text}</p>
                </CardBody>
            </Card>
        )
    }
}

